export default {
      id: "ic_consulter-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ic_consulter-usage",
      toString: function () {
        return this.url;
      }
    }